<template>
  <div class="breadcrumbs">
    <ul class="breadcrumbs__list">
      <li class="breadcrumbs__item">
        <a class="breadcrumbs__link" href="/" :title="in18['page_home']">
          <img alt="" class="img" src="/shop/images/breadcrumbs-home-v1.svg">
        </a>
      </li>
      <li v-if="product.category" v-for="parent in product.category.parents" class="breadcrumbs__item">
        <a :href="parent.link" :title="parent.title" class="breadcrumbs__link">
          {{ parent.title }}
        </a>
      </li>
      <li class="breadcrumbs__item">
        {{ product.title }}
      </li>
    </ul>
  </div><!-- /.breadcrumbs -->
</template>

<script>
export default {
  name:  'ProductBreadcrumbs',
  props: {
    product: Object,
    in18:       {
      type: Object,
    },
  },
};
</script>